import { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';

export const useUrlSku = (): [string | undefined, (sku: string) => void] => {
  const { replace, asPath } = useRouter();

  //it uses asPath instead of query from useRouter to avoid page shifting. query is not updated until the page is fully loaded
  const sku = useMemo(() => {
    const urlQuery = new URLSearchParams(asPath.split('?')[1]);
    return urlQuery.get('sku') || '';
  }, [asPath]);

  const updateSkuInUrl = useCallback(
    (newSku: string): void => {
      const queryString = new URLSearchParams({ sku: newSku });

      if (sku !== newSku) {
        replace({ pathname: `${asPath.split('?')[0]}`, query: queryString.toString() }, undefined, {
          shallow: true,
        }).catch(console.error);
      }
    },
    [replace, asPath, sku]
  );
  return [sku, updateSkuInUrl];
};
